import { useState } from 'react';
import PropTypes from 'prop-types';

// Utils
import { cn } from '@repo/zolintra-utils';
import { isAfter, isBefore, isEqual } from 'date-fns';
import { sortBy } from 'lodash';

// Styles
import styles from './CalendarRow.module.css';

// Components
import { EmployeInformation } from '../EmployeInformation/EmployeInformation';

function CalendarRow({
  days, resource, handleDayClick, isDayClickDisabled, children,
}) {
  const [firstDayPressed, setFirstDayPressed] = useState(null);
  const [lastDayHovered, setLastDayHovered] = useState(null);

  return (
    <div
      className={styles.gridRow}
      style={{
        gridTemplateColumns: `var(--size-res-id) repeat(${days.length}, 1fr)`,
      }}
    >
      <div className={cn([styles.gridCell, styles.resource])}>
        <EmployeInformation resource={resource} />
      </div>

      {days.map((day, index) => {
        const isDisabled = isDayClickDisabled(day);

        return (
          <button
            type="button"
            aria-label={`Select day ${day.day}`}
            tabIndex={0}
            key={`${day.year}-${day.month}-${day.day}`}
            disabled={isDisabled}
            className={cn([
              styles.gridCell,
              styles.cellDay,
              day.dayOfWeek === 1 && index !== 0 ? styles.weekend : '',
              firstDayPressed && isAfter(day.date, firstDayPressed) && (isBefore(day.date, lastDayHovered) || isEqual(day.date, lastDayHovered)) ? styles.selectedRange : '',
            ])}
            onMouseDown={() => {
              if (!isDisabled) setFirstDayPressed(day.date);
            }}
            onMouseUp={() => {
              if (!isDisabled && firstDayPressed) {
                handleDayClick(sortBy([firstDayPressed, day.date]));
              }
              setFirstDayPressed(null);
              setLastDayHovered(null);
            }}
            onMouseOver={() => setLastDayHovered(day.date)}
            onFocus={() => {}}
            style={{
              gridColumn: `${index + 2} / ${index + 2}`,
            }}
          />
        );
      })}
      {children()}
    </div>
  );
}

CalendarRow.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape({})),
  resource: PropTypes.shape({}),
  handleDayClick: PropTypes.func,
  isDayClickDisabled: PropTypes.func,
  children: PropTypes.func,
};

CalendarRow.defaultProps = {
  days: [],
  resource: {},
  handleDayClick: () => {},
  isDayClickDisabled: () => {},
  children: () => {},
};

export default CalendarRow;
